<template>
    <div>
        <!-- 退出登录 -->
        <logOut />
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
        >
            <van-cell v-for="(item, index) in remindList" :key="index">
                <div style="display: flex;align-items: center;">
                    <img :src="item.url" alt="" style="height: 50px;border-radius: 50%;">
                    <div style="margin: 0px 20px;width: 200px;">
                        <p>{{item.name}}</p>
                        <p>阅读了{{item.contentTypeStr}}：
                            <span style="color: #666;word-break: break-word;">{{item.contentTitle}}</span>
                        </p>
                        <p>阅读时长：
                            <span style="color: #666">{{item.duration}}
                            </span>秒
                        </p>
                    </div>
                    <div style="width: 120px;">{{item.startTime}}</div>
                </div>
            </van-cell>
        </van-list>
    </div>
</template>
<script>
import { timeFormat } from '@/utils/index.js'
import logOut from "./logOut"

export default {
    data() {
        return {
            loading: false,
            finished: false,
            remindList: []
        }
    },
    components: { logOut },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.loading = true
            this.$http.get("/scrm/v1/wxcp-chat-tool/p/findByShareUserId", {
                params: {
                    page: 1,
                    pageCount: 10000,
                },
            }).then((res) => {
                const { code, data } = res
                if (code === 1) {
                    if (data !== null) {
                        this.remindList = data.records
                        this.remindList.forEach(item => {
                            item.startTime = timeFormat(item.startTime, 'yyyy/MM/dd hh:mm:ss')
                        })
                        this.loading = false
                        this.finished = true
                    }
                }
            })
        }
    }
}
</script>